<template>
  <b-card>
    <div v-if="$route.name !== 'users' && title" class="pt-1">
      <h5>
        {{ title }}
      </h5>
    </div>
    <div class="d-flex justify-content-between flex-wrap align-items-center">
      <b-form class="d-flex align-items-center" @submit.prevent="onSearch">
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>

      <div class="d-flex">
        <b-button
          class="my-1 mr-50"
          variant="outline-primary"
          @click="visible = true"
        >
          {{ $route.params.id ? "اضافه کردن کاربر" : "ایجاد کاربر" }}
        </b-button>
        <b-button class="my-1" variant="outline-danger" @click="removeUsers">
          حذف کاربران
        </b-button>
      </div>
    </div>
    <data-table
      :fields="fields"
      :items="users"
      :loading="loading"
      @onRowClicked="
        $router.push({
          name: 'users-profile-road-map',
          params: { id: $event.id },
        })
      "
    >
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-model="removeUsersData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #id="{ data }">
        <span>{{ data.item.id }} </span>
      </template>
      <template #avatar="{ data }">
        <b-avatar
          size="32"
          :src="data.item.avatar"
          :text="data.item.fullname"
          :variant="`light-primary`"
        />
      </template>
      <template #firstname="{ data }">{{
        data.item.first_name || "-"
      }}</template>
      <template #lastname="{ data }">
        <div style="white-space: nowrap">
          {{ data.item.last_name || "-" }}
        </div>
      </template>
      <template #phone="{ data }">
        <div style="white-space: nowrap">
          <b-badge
            variant="light-success"
            class="ml-25"
            v-if="data.item.mobile_verified_at"
            ><feather-icon class="rounded-lg" icon="CheckIcon"
          /></b-badge>

          {{ data.item.mobile ? "0" + data.item.mobile : "-" }}
        </div>
      </template>
      <template #manual="{ data }">
        <span v-if="data.item.pivot && data.item.pivot.manual">
          <b-badge> دستی </b-badge>
        </span>
        <span v-else>-</span>
      </template>
      <template #role="{ data }">{{ data.item.role || "-" }}</template
      >gender
      <template #gender="{ data }">{{
        data.item.gender ? "زن" : "مرد"
      }}</template>

      <template #email="{ data }"
        ><div style="white-space: nowrap">
          <b-badge
            variant="light-success"
            class="ml-25"
            v-if="data.item.email_verified_at"
            ><feather-icon class="rounded-lg" icon="CheckIcon"
          /></b-badge>
          {{ data.item.email || "-" }}
        </div></template
      >

      <template #actions="{ data }">
        <div class="d-flex justify-content-around">
          <b-button
            size="sm"
            variant="flat-secondary"
            @click="enter(data.item.id)"
            style="white-space: nowrap"
          >
            <feather-icon icon="CheckCircleIcon" />
            <span class="ml-50">ورود</span>
          </b-button>
          <b-button
            size="sm"
            variant="flat-primary"
            :to="{
              name: 'users-profile-road-map',
              params: { id: data.item.id },
            }"
            style="white-space: nowrap"
          >
            <feather-icon icon="EyeIcon" />
            <span class="ml-50">مشاهده</span>
          </b-button>
          <b-button
            size="sm"
            variant="flat-warning"
            :to="{
              name: 'user-edit',
              params: {
                id: data.item.id,
              },
            }"
            style="white-space: nowrap"
          >
            <feather-icon icon="EditIcon" />
            <span class="ml-50">ویرایش</span>
          </b-button>

          <b-button
            size="sm"
            variant="flat-danger"
            @click="removeUser(data.item)"
            style="white-space: nowrap"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">حذف</span>
          </b-button>
        </div>
      </template>
    </data-table>

    <add-users v-model="visible" :visible="visible" @updateUsers="getUsers" />
    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div class="col-md-3 pl-0">
        <b-form-checkbox v-model="selectAll" class="ml-2">
          انتخاب همه</b-form-checkbox
        >
      </div>
      <div class="col-md-6 d-flex justify-content-md-center align-items-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BAvatar,
  BFormInput,
  BCard,
  BForm,
  BFormCheckbox,
  BFormGroup,
} from "bootstrap-vue";
import AddUsers from "./add-user/AddUsers.vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BBadge,
    BForm,
    BFormInput,
    BPagination,
    BLink,
    BAvatar,
    BCard,
    BFormCheckbox,
    AddUsers,
    BFormGroup,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      selectAll: false,
      removeUsersData: [],
      users: [],
      loading: false,
      choosenPage: 1,
      url: "",
      title: "",
      titleUrl: "",
      search: "",
      currentPage: 1,
      pagination: {},
      visible: false,
      fields: [
        { key: "selectuser", label: "" },
        { key: "id", label: "شناسه" },
        { key: "avatar", label: "" },
        { key: "firstname", label: "نام" },
        { key: "lastname", label: "نام خانوادگی" },
        { key: "manual", label: "نوع" },
        { key: "phone", label: "تلفن" },
        { key: "gender", label: "جنسیت" },
        { key: "role", label: "نقش" },
        { key: "email", label: "ایمیل" },
        { key: "actions", label: "عملیات" },
      ],
    };
  },
  watch: {
    selectAll: {
      handler(val) {
        val
          ? (this.removeUsersData = this.users.map((user) => user.id))
          : (this.removeUsersData = []);
      },
      immediate: true,
    },
    removeUsersData: {
      handler(val) {
        val.length == this.users.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    $route: {
      async handler(val) {
        this.removeUsersData = [];
        this.checkUrl();
        this.getUsers();
        this.getTitle();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: this.$route.fullPath.includes("semesters")
            ? "users-semester"
            : this.$route.fullPath.includes("courses")
            ? "students-course"
            : `users`,
          params: {
            id:
              this.$route.fullPath.includes("semesters") ||
              this.$route.fullPath.includes("courses")
                ? this.$route.params.id
                : "",
          },
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        this.$router.push({
          name: this.$route.fullPath.includes("semesters")
            ? "users-semester"
            : this.$route.fullPath.includes("courses")
            ? "students-course"
            : `users`,
          params: {
            id:
              this.$route.fullPath.includes("semesters") ||
              this.$route.fullPath.includes("courses")
                ? this.$route.params.id
                : "",
          },
        });
      }
    },
  },
  created() {
    if (this.$route.query.key) {
      this.$router.push({
        name: this.$route.fullPath.includes("semesters")
          ? "users-semester"
          : this.$route.fullPath.includes("courses")
          ? "students-course"
          : `users`,
        params: {
          id:
            this.$route.fullPath.includes("semesters") ||
            this.$route.fullPath.includes("courses")
              ? this.$route.params.id
              : "",
        },
      });
    }
  },
  methods: {
    checkUrl() {
      if (this.$route.fullPath.includes("semester")) {
        this.url = "/panel/semesters/" + this.$route.params.id + "/students";
        this.titleUrl = "/panel/semesters/" + this.$route.params.id;
      } else if (this.$route.fullPath.includes("courses")) {
        this.url = "/panel/courses/" + this.$route.params.id + "/students";
        this.titleUrl = "/panel/courses/" + this.$route.params.id;
      } else {
        this.url = `/panel/users`;
        this.titleUrl = "";
      }
    },
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async enter(id) {
      try {
        const { data } = await this.$http.post(
          "/panel/personal-access-tokens",
          {
            user_id: id,
          }
        );
        await localStorage.setItem(
          "user_token",
          JSON.stringify({
            val: data.data.token,
            type: data.data.type,
          })
        );
        await localStorage.setItem(
          "tempUserData",
          JSON.stringify(data.data.user)
        );
        setTimeout(() => {
          window.location.replace("/");
        }, 500);
      } catch (err) {}
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: this.$route.fullPath.includes("semesters")
            ? "users-semester"
            : this.$route.fullPath.includes("courses")
            ? "students-course"
            : `users`,
          params: {
            id:
              this.$route.fullPath.includes("semesters") ||
              this.$route.fullPath.includes("courses")
                ? this.$route.params.id
                : "",
          },
          query: {
            key: !isNaN(+this.search) ? +this.search : this.search,
          },
        });
      }
    },
    removeUser(item) {
      if (
        this.$route.path.includes("courses") ||
        this.$route.path.includes("semesters")
      ) {
        this.$bvModal
          .msgBoxConfirm(
            this.$route.path.includes("courses")
              ? `آیا میخواهید این کاربر از دوره حذف شود ؟`
              : `آیا میخواهید این کاربر از ترم حذف شود ؟`,
            {
              size: "sm",
              bodyClass: "h5 my-2",
              okVariant: "primary",
              okTitle: "بله",
              cancelTitle: "خیر",
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.$http.delete(
                  this.$route.path.includes("courses")
                    ? `/panel/courses/${this.$route.params.id}/students/${item.id}`
                    : `/panel/semesters/${this.$route.params.id}/students/${item.id}`
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeUsersData = [];
                  await this.getUsers();
                } else {
                  await this.$router.push({
                    name: this.$route.path.includes("courses")
                      ? "students-course"
                      : "users-semester",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "کاربر با موفقیت حذف شد.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$bvModal
          .msgBoxConfirm("آیا میخواهید این کاربر حذف شود ؟", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "بله",
            cancelTitle: "خیر",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.$http.delete(`/panel/users/${item.id}`);
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeUsersData = [];
                  await this.getUsers();
                } else {
                  await this.$router.push({
                    name: "users",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "کاربر با موفقیت حذف شد.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "مشکلی پیش آمده است",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      }
    },
    removeUsers() {
      if (
        this.$route.path.includes("courses") ||
        this.$route.path.includes("semesters")
      ) {
        if (this.removeUsersData.length) {
          this.$bvModal
            .msgBoxConfirm(
              this.$route.path.includes("courses")
                ? `آیا میخواهید این کاربران از دوره حذف شوند ؟`
                : `آیا میخواهید این کاربران از ترم حذف شوند ؟`,
              {
                size: "sm",
                bodyClass: "h5 my-2",
                okVariant: "primary",
                okTitle: "بله",
                cancelTitle: "خیر",
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
            )
            .then(async (value) => {
              if (value) {
                this.loading = true;
                try {
                  await new Promise((resolve, reject) => {
                    this.removeUsersData.map(async (user, index) => {
                      await this.$http.delete(
                        this.$route.path.includes("courses")
                          ? `/panel/courses/${this.$route.params.id}/students/${user}`
                          : `/panel/semesters/${this.$route.params.id}/students/${user}`
                      );
                      if (index + 1 == this.removeUsersData.length) {
                        resolve();
                      }
                    });
                  });
                  if (!this.$route.query.page || this.$route.query.page == 1) {
                    this.removeUsersData = [];
                    await this.getUsers();
                  } else {
                    await this.$router.push({
                      name: this.$route.fullPath.includes("semesters")
                        ? "users-semester"
                        : this.$route.fullPath.includes("courses")
                        ? "students-course"
                        : `users`,
                      query: { page: 1 },
                    });
                    this.currentPage = await this.$route.query.page;
                  }
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "کاربران با موفقیت حذف شدند.",
                      icon: "EditIcon",
                      variant: "success",
                    },
                  });
                } catch (err) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "مشکلی پیش آمده است",
                        icon: "InfoIcon",
                        variant: "danger",
                      },
                    },
                    { position: "bottom-right" }
                  );
                }
                this.loading = false;
              }
            });
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "کاربری انتخاب نشده است",
                icon: "InfoIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        }
      } else {
        if (this.removeUsersData.length) {
          this.$bvModal
            .msgBoxConfirm("آیا میخواهید کاربران انتخاب شده حذف شوند ؟", {
              size: "sm",
              bodyClass: "h5 my-2",
              okVariant: "primary",
              okTitle: "بله",
              cancelTitle: "خیر",
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            })
            .then(async (value) => {
              if (value) {
                this.loading = true;
                try {
                  await this.removeUsersData.map(
                    async (user) =>
                      await this.$http.delete(`/panel/users/${user}`)
                  );
                  if (!this.$route.query.page || this.$route.query.page == 1) {
                    this.removeUsersData = [];
                    await this.getUsers();
                  } else {
                    await this.$router.push({
                      name: "users",
                      query: { page: 1 },
                    });
                    this.currentPage = await this.$route.query.page;
                  }

                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "کاربران با موفقیت حذف شدند.",
                      icon: "EditIcon",
                      variant: "success",
                    },
                  });
                } catch (err) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "مشکلی پیش آمده است",
                        icon: "InfoIcon",
                        variant: "danger",
                      },
                    },
                    { position: "bottom-right" }
                  );
                }
                this.loading = false;
              }
            });
        } else {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "کاربری انتخاب نشده است",
                icon: "InfoIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        }
      }
    },
    async getUsers() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          includes: ["roles"],
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
        });
        this.users = data.data.users;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
    async getTitle() {
      try {
        const { data } = await this.$http.get(this.titleUrl);
        this.title = data.data.name;
      } catch (err) {}
    },
  },
};
</script>
